module.exports = __webpack_public_path__ + "static/media/trainer.8f07786a.webp";